import React from 'react';
import MappedRoutes from './components/common/mappedRoutes';
import { ToastContainer, toast } from 'react-toastify';
import Loader from './components/common/loader';

class Content extends React.Component {
    constructor() {
        super();
        this.state = { showProgress: false }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.operationError !== prevProps.operationError) {
            toast.error(this.props.operationError, {
                position: toast.POSITION.TOP_RIGHT,
                className: 'message failed dam-msg-icon--error fa fa-times-circle'
            });
        }

        if (prevProps.showProgress !== this.props.showProgress) {
            this.setState({ showProgress: this.props.showProgress });
        }
    }

    render() {
        return (
            <div className="body-content">
                <ToastContainer />
                {this.state.showProgress && <Loader />}
                <div className="full-width">
                    <MappedRoutes />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        operationError: state.operationError.error,
        showProgress: state.showProgress
    };
};

export default Content;